import { ActionTypes } from "../constants/action_types";

const initialValue = null;

export const alertMessageReducer = (state = initialValue, { type, payload }) => {
    switch (type) {
        case ActionTypes.ALERT_MESSAGE:
            return payload
        default:
            return state;
    }
}